import { render, staticRenderFns } from "./CurrentVotings.vue?vue&type=template&id=05825b27&"
import script from "./CurrentVotings.vue?vue&type=script&lang=js&"
export * from "./CurrentVotings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports